<template>
  <div class="row justify-content-center" style="">
    <div class="col-12 col-md-10 col-lg-8 col-xl-8">
      <div class="tit text-center">
        <h2>Dados bancários</h2>
      </div>
    </div>
    <bank-data-form :bank-data="bankData" @submit="handleSubmit"/>
  </div>
</template>

<script>
  import BankDataForm from '@/components/BankDataForm'

  export default {
    components: { BankDataForm },
    props: {
      investor: {type: Object, required: true}
    },
    computed: {
      bankData: function() {
        const bankData = this.investor.DadosBancarios || {}
        return {
          bankCode: bankData.CodigoBanco,
          agency: bankData.Agencia,
          account: bankData.Conta,
          accountType: bankData.TipoConta,
        }
      }
    },
    methods: {
      handleSubmit(formData) {
        this.$emit('submit', {
          DadosBancarios: {
            CodigoBanco: formData.bankCode,
            Agencia:     formData.agency,
            Conta:       formData.account,
            TipoConta:   formData.accountType
          },
          NaoTemContaBancaria: formData.hasNoAccount
        })
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/AdditionalInformationInvestor/PassoDadosBancarios.vue